import { AnnotationComponentProps } from "@pages/Article/components/StoryElements/Annotation/utils/types";

export default function AnnotationComponentCapitals({
  children,
}: AnnotationComponentProps): React.ReactElement {
  return <span className="uppercase">{children}</span>;
}
